module.exports = __webpack_public_path__ + "img/lisabackground.889d9b22.svg";